/**
 * Created by zhaoyao on 19:45.
 * 新建免打扰时段
 */
import React from 'react';
import {Icon, Divider, Button, Select } from "antd";
import {fetchGet, fetchPost} from "../../utils/fetchRequest";
import {API} from "../../configs/api.config";
import  {Toast, DatePicker, List } from "antd-mobile";
import moment from 'moment'

const Option = Select.Option;
class AddNoDisturbing extends React.Component{

    componentWillMount() {
        document.title = "新建免打扰时段";
    }
    constructor(props){
        super(props);
        this.state={
            name:'addNoDisturbing',
            data:{

            },
            IMEI: this.props.match.params.IMEI,
            startTime: null,
            endTime: null,
            period: null,
        };
    }


    componentDidMount(){

    }
     handleChange = (value) => {
      console.log(`selected ${value}`);
      this.setState({
          period: value,
      })
    }
    render(){

        const CustomChildren = ({ extra, onClick, children }) => (
          <div
            onClick={onClick}
            style={{ backgroundColor: '#fff', height: '45px', lineHeight: '45px', padding: '0 15px' }}
          >
            {children}
            <span style={{ float: 'right', color: '#888' }}>{extra}</span>
          </div>
        );
        return (<div>

                <div className="comhline_sty"></div>
                <DatePicker
                          mode="time"
                          format="HH:mm"
                          title=""
                          locale={{
                               okText: '确定',
                               dismissText: '取消'
                           }}
                          value={this.state.startTime}
                          onChange={v => this.setState({ startTime: v })}
                          extra="请设置"
                        >
                          <CustomChildren>开始时间</CustomChildren>
                        </DatePicker>
                        <DatePicker
                                  mode="time"
                                  format="HH:mm"
                                  title=""
                                  locale={{
                                       okText: '确定',
                                       dismissText: '取消'
                                   }}
                                  value={this.state.endTime}
                                  onChange={v => this.setState({ endTime: v })}
                                  extra="请设置"
                                >
                                  <CustomChildren>结束时间</CustomChildren>
                                </DatePicker>

                <div className="comhline_sty"></div>


                <div className="flex_row padding_10  bg_white">
                     <div className="flex_column">
                          <div className="span_14  text_bold">重复</div>
                      </div>
                      <div className="flex_center_vertical_end item_flex">
                        <Select showSearch
                          style={{ width: 200 }}
                          placeholder="时段"
                          optionFilterProp="children"
                          notFoundContent="无法找到"
                          searchPlaceholder="输入关键词"
                          onChange={this.handleChange}>
                          <Option value="周一到周五">周一到周五</Option>
                          <Option value="周六">周六</Option>
                          <Option value="周日">周日</Option>
                        </Select>

                      </div>
                </div>
                <div className="notify-item-line"></div>

            <Button className='commonButton' type='primary' style={{margin: '35px',borderRadius:30,width: '80%'}}
                                                onClick={this.onNextClick}>保存</Button>

        </div>)
    }
    onNextClick = (value) => {

        if (this.state.startTime == null || this.state.startTime == '') {
            Toast.fail('请输入开始时间')
            return
        }
        if (this.state.endTime == null || this.state.endTime == '') {
            Toast.fail('请输入结束时间！')
            return
        }
        var startT = new Date(this.state.startTime).getTime()
        var endT = new Date(this.state.endTime).getTime()
        if (startT >= endT) {
            Toast.fail('结束时间必须大于开始时间')
            return
        }
        const paramObj = {
            IMEI: this.state.IMEI,
            startTime: moment(this.state.startTime).format('HH:mm'),
            endTime: moment(this.state.endTime).format('HH:mm'),
            period: this.state.period,
        }
          fetchPost(API.ADD_NO_DISTURBING, {
                jsonAlbum: JSON.stringify(paramObj)
            }).then(response => {
                if (response.success) {

                    this.backTask = setTimeout(() => {
                        this.props.history.goBack();
                    }, 1000)
                }

            }).catch(error => {
                Toast.hide();

                if (typeof error === 'string') {
                    Toast.fail(error, 2)
                } else {
                    Toast.fail('请求异常', 2)
                }
          })
    }

}

export  default AddNoDisturbing;